export const textSearchBtn = "Search";
export const textResetBtn = "เริ่มใหม่";
export const textCreateBtn = "Add";
export const textSaveBtn = "บันทึก";
export const textCancleBtn = "ยกเลิก";
export const textEditBtn = "แก้ไข";
// color
export const colorSearchBtn = "#fff";
export const colorResetBtn = "#5FB045";
export const colorSubmitBtn = "#5FB045";
export const colorCreateBtn = "#0069FF";
export const colorSaveBtn = "#5FB045";
export const colorCancleBtn = "#676C6F";
export const colorEditBtns = "transparent";
// icon
export const iconSearchBtn = "fas fa-search";
export const iconResetBtn = "fas fa-undo";
export const iconCreateBtn = "+";
// color shadow hover
export const hoverSearchBtn = "#d4d4d4";
export const hoverResetBtn = "#447c31";
export const hoverSubmitBtn = "#447c31";
export const hoverCreateBtn = "#015BDB";
export const hoverSaveBtn = "#447c31";
export const hoverCancleBtn = "#3f4244";
export const hoverEditBtns = "transparent";
